import { Redirect, Route, Switch, Router } from 'react-router-dom';
import { history } from '../store';
import Investors from '../components/investors';
import OnboardingRouter from '../components/onboarding/Router';
import MobileLogin from '../components/auth/MobileLogin';
import LoginOtp from '../components/auth/loginOtp';
import RedirectRoute from './RedirectRoute';
import ProtectedRoute from './ProtectedRoute';
import ApplicationRoutes from '../components/investors/routes';
import Profile from '../components/profile/index';
import ApplicationDetails from '../components/ApplicationDetails/index';
import { useEffect } from 'react';
import { useSnackbar, VariantType } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../redux-store/reducers';
import InvestorRoutes, { EditApplication } from '../components/Investments/routes';
import UserManagementLayOut from '../components/userManagement/router';
import { NOTIFICATIONS_LIMIT, USER_ROLES } from '../utils/constant';
import { FundsSetup } from '../components/FundsSetup';
import { RiskProfile } from '../components/RiskProfile';
import { AMCAdminsList } from '../components/AmcAdmins';
import ApplicationEsignList from '../components/ApplicationsEsignList';
import { CLEAR_GLOBAL_ERROR } from '../redux-store/types/auth';
import { useModal } from 'mui-modal-provider';
import SimpleDialog, { CommonLayout } from '../components/commonComponents';
import NonIndividualApplicationRoutes, {
  NonIndividualApplicationEdit,
} from '../components/NonIndividualInvestor/routes';
import Reports from '../components/Reports/reports';
import { NonIndividualApplicationDetail } from '../components/NonIndividualApplicationDetails';
import ConsentEmailApproveReject, {
  ConsentEmailApplicationsList,
  ConsentEmailApprove,
  ConsentEmailReject,
} from '../components/ConsentEmailComponent';
import adminSupport from '../components/adminSupport';
import LoginRequireRoute from './LoginRequireRoute';
import Dashboard from '../components/dashboard';
import InvestorDashboard from '../components/dashboard/investor-dashboard';
import InvestorDetails from '../components/dashboard/investor-details';
import TotalRmDetail from '../components/dashboard/total-rm-detail';
import BookSizeDetail from '../components/dashboard/book-size-details';
import NetSales from '../components/dashboard/net-sales';
import TotalRevenue from '../components/dashboard/total-revenue';
import GrossSales from '../components/dashboard/gross-sales';
import IndividualInvestor from '../components/dashboard/individual-investor';
import ProductDetails from '../components/dashboard/product-details';
import DirectEquity from '../components/dashboard/direct-equity/direct-equity';
import { getAnalystDetails, getRmDetails } from '../redux-store/actions/userManagement';
import PMS from '../components/dashboard/pms/pms';
import InvestorReportRoute from '../components/InvestorReport/routesReport';
import AIF from '../components/dashboard/aif';
import Bonds from '../components/dashboard/bonds/index';
import InvestorTransactions from '../components/dashboard/investor-transaction/investor-transactions';
import DashboardReportRoute from '../components/dashboard/Reports_Dashboard/routes';
import { formatDate, isModuleAllowed } from '../utils/utilityFunctions';
import RecommendedSchemes from '../components/dashboard/investor-transaction/recommended-schemes'
import Holding from '../components/dashboard/investor-transaction/holdings'
import STP_SWP from '../components/dashboard/investor-transaction/STP-SWP'
import SwitchComp from '../components/dashboard/investor-transaction/Switch'
import Redeem from '../components/dashboard/investor-transaction/Redeem'
import SIPLumpsum from '../components/dashboard/investor-transaction/SIP-Lumpsum'
import SIP from '../components/dashboard/investor-transaction/SIP-Lumpsum'
import InvestorProfileRouter from "../components/investorOverview/InvestorProfileRouter";
import IndividualFundDetails from '../components/investorOverview/fundDetails';
import InvestorLoginRouter from '../components/investorOverview/InvestorLoginRouter';
import InvestorRecommendations from '../components/investorOverview/InvestorRecommendations';
import { storeInvestorClientId, storeIwappId } from '../redux-store/actions/id';
import { getCartItemsCount, setCartItemsCount } from '../redux-store/actions/cart';
import { GetCartItemsCountResponseBody } from '../redux-store/types/cart';
import CategoryWiseActionItems from '../components/investorOverview/mutualFund/CategoryWiseActionItems';
import SidebarMFCategoryWiseBreakup from '../components/dashboard/SidebarMFCategoryWiseBreakup';
import ProductsRouter from '../components/products/productsRouter';
import JointHolderType from '../components/auth/JointHolderType';
import { getInvestorDetails } from '../redux-store/actions/investorProfile';
import { getBusinessDate, setNavbarInfo, setNavbarInfoLoading, storeNotifications } from '../redux-store/actions/navbarInfo';
import { GetBusinessDateResponseBody } from '../redux-store/types/navbarInfo';
// import Analytics from '../components/analytics';
import FamilyProfileDetails from '../components/FamilyProfileDetails';
import AnalyticsRouter from '../components/analytics/analyticsRouter';
import OnBoardingDashBoard from '../components/OnBoardingDashboard/index'
import { getCurrencyInfo, setCurrencyInfo } from '../redux-store/actions/currencyInfo';
import { GetCurrencyInfoResponseBody } from '../redux-store/types/currencyInfo';
import OrderManagementRouter from '../components/orderManagement/orderManagementRouter';
import OrdersApproval from '../components/ordersApproval';
import OrderDetails from '../components/ordersApproval/orderDetails';
import PaymentsApproval from '../components/paymentsApproval';
import PaymentDetails from '../components/paymentsApproval/paymentDetails';
import InvOnboardingRoutes from '../components/InvestorOnboarding/InvOnboardingRoutes';
import InvApplicationRoutes from '../components/InvestorOnboarding/InvApplicationRoutes';
import CartRouter from '../components/Cart/CartRouter';
import PaymentRouter from '../payment/paymentRouter';
import BseTradeSuccess from '../components/investorOverview/BseTradeSuccess';
import Dummy from '../components/dummy';
import KycDocSelection from '../components/investors/KycDocSelection';
import AccountStatus from '../components/JointHolder/AccountStatus';
import CreateJointHolder from '../components/JointHolder/CreateJointHolder';
import { JointHolderDetails } from '../components/JointHolder/JointHolderDetails';
import ReKYCStatus from '../components/reKyc/ReKYCStatus';
import ConsentOtp from '../components/ConsentOtp';
import { Digilocker } from '../components/investors/digilocker';
import VerifyFormSubmitOTP from '../components/ConsentOtp/VerifyFormSubmitOTP';
import CKYCPage from '../components/investors/CKYCPage';
import { getCheckerDetails } from '../redux-store/actions/orderApproval';
import SelectRole from '../components/auth/SelectRole';
import uploadRMMapping from '../components/uploadRMMapping';
import Notifications from '../components/Notifications/Notifications';
import { GetNotificationsResponseBody } from '../redux-store/types/api-types';
import { getNotifications } from '../redux-store/actions/notifications';
import NonMFApplications from '../components/nonKyc';
import OVDReports from '../components/Reports/OVDReports';
import BanksRouter from '../components/banks/banksRouter';
import NomineeRouter from '../components/nominee/nomineeRouter';
import UpdateBank from '../components/banks';
import UpdateNominee from '../components/nominee';
import FamilyDetails from '../components/FamilyDetails';
import MyProfileRouter from '../components/MyProfile/MyProfileRouter';
import AppLauncher from '../components/appLauncher';
import LoadingAdid from '../ui/LoadingAdid';
import NomineeRequiredPopup from '../components/nominee/NomineeRequiredPopup';
import SubbrokerReports from '../components/Reports/subbrokerReport/SubbrokerReports';



// import Orders from '../components/dashboard/investor-transaction/orders'

function AppRoutes(): JSX.Element {
  const dispatch = useDispatch();
  const { toaster, message, severity } = useSelector((state: RootStateType) => state.toast);
  const { id: userId, role = '', token = '', subRole = "", diyAccountType = '', diyIsKycDone = false, diyInvestorOnboardingEdit = false, diyInvOnboardingPrev = false, diyInvestorOnboarding = false, permissions = [] } = useSelector((state: RootStateType) => state.auth);
  const { selectedPortfolio } = useSelector((state: RootStateType) => state.selectedPortfiolio)
  const { enqueueSnackbar } = useSnackbar();
  const { showModal, state: modalState } = useModal();
  const errorState = useSelector((store: RootStateType) => store.error);
  const { investorClientId = '', clientInterfaceCode, applicationId = '' } = useSelector((store: RootStateType) => store.id);
  useEffect(() => {
    toaster && enqueueSnackbar(message, { variant: severity as VariantType });
  }, [toaster]);

  useEffect(() => {
    if (errorState && Object.keys(modalState ?? {}).length === 0) {
      const { error = '' } = errorState;
      const { destroy } = showModal(SimpleDialog, {
        content: error,
        actions: [
          {
            label: 'OK',
            onClick: () => {
              destroy();
              dispatch({ type: CLEAR_GLOBAL_ERROR });
            },
          },
        ],
      });
    }
  }, [errorState]);

  useEffect(() => {
    const fetch = async () => {

      let navbarInfoData = {
        rmName: "",
        businessDate: "",
        company: "",
        environment: "",
        userRole: ""
      }

      let rmId = '';

      try {
        const urlContent = window.location.pathname.split("/")
        if (urlContent[1] === 'payment-flow') return;

        // Currency and Business date API start

        if (token) {
          dispatch(setNavbarInfoLoading(true));

          const [getCurrencyInfoResponse, getBusinessDateResponse] = await Promise.allSettled([
            dispatch(getCurrencyInfo() as unknown as Promise<GetCurrencyInfoResponseBody>),
            dispatch(getBusinessDate() as unknown as Promise<GetBusinessDateResponseBody>)
          ])

          if (getCurrencyInfoResponse?.status === "fulfilled" && getCurrencyInfoResponse?.value?.isSuccess) {
            const currencyInfoDetails = getCurrencyInfoResponse?.value?.result as any;

            dispatch(setCurrencyInfo({
              locale: currencyInfoDetails?.locale ?? "en-IN",
              currencyCode: currencyInfoDetails?.currencyCode ?? "INR",
              currencySymbol: currencyInfoDetails?.currencySymbol ?? "20B9"
            }));
          }

          if (getBusinessDateResponse?.status === "fulfilled" && getBusinessDateResponse?.value?.isSuccess) {
            const businessDateResult = getBusinessDateResponse?.value?.result as any;
            const currentEnvironment = getBusinessDateResponse?.value?.environment ?? "";
            const currentCompany = businessDateResult?.companyName?.split(" ")[0] ?? "";

            navbarInfoData = {
              ...navbarInfoData,
              businessDate: businessDateResult?.businessDate ?? "",
              environment: currentEnvironment ?? "",
              company: currentCompany ?? ""
            }
          }
        }

        // Currency and Business date API end

        if (userId && ![USER_ROLES.INVESTOR].includes(role)) {
          dispatch(setNavbarInfoLoading(true));

          const getRmDetailsResponse = (await dispatch(getRmDetails())) as unknown as any;

          if (getRmDetailsResponse) {
            rmId = getRmDetailsResponse?.iwappRmId ?? ""
            dispatch(storeIwappId({ iwappRmId: getRmDetailsResponse?.iwappRmId ?? "" }));

            navbarInfoData = {
              ...navbarInfoData,
              rmName: getRmDetailsResponse?.name ?? "",
              userRole: getRmDetailsResponse?.userRole ?? ""
            }
          }
        }

        if (userId && role === USER_ROLES.INVESTOR) {
          dispatch(setNavbarInfoLoading(true));

          const urlContent = window.location.pathname.split("/")

          if (!(urlContent[1] === "investment-details" && urlContent[3] === "application-details" && urlContent.length === 4)) {

            if (selectedPortfolio?.value) {

              const { isSuccess, cartItemsCount } = await (dispatch(getCartItemsCount({
                clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                portfolioId: selectedPortfolio?.value
              })) as unknown as Promise<GetCartItemsCountResponseBody>)

              if (isSuccess) {
                dispatch(setCartItemsCount(cartItemsCount));
              }
            }
          }
        }

        if (userId && [USER_ROLES.ANALYST].includes(role)) {
          dispatch(setNavbarInfoLoading(true));

          const getAnalystDetailsResponse = (await dispatch(getAnalystDetails())) as unknown as any;

          if (getAnalystDetailsResponse) {

            dispatch(storeIwappId({ iwappRmId: getAnalystDetailsResponse?.analystId ?? "" }));

            navbarInfoData = {
              ...navbarInfoData,
              rmName: getAnalystDetailsResponse?.name ?? "",
              userRole: getAnalystDetailsResponse?.userRole ?? ""
            }
          }
        }
        //notifiactions call

        if (userId) {
          const notificationsPayload = {
            rmId: [USER_ROLES.RM].includes(role) ? [`${rmId}`] : [],
            category: [],
            clientCode: [USER_ROLES.INVESTOR].includes(role) ? [clientInterfaceCode] : [],
            limit: 3,
            page: 1,
            sort: 'notificationTimestamp',
            order: 'DESC'
          }
          const getNotificationsData = (await dispatch(getNotifications(notificationsPayload))) as unknown as GetNotificationsResponseBody;
          dispatch(storeNotifications(getNotificationsData.data ?? []));
        }
        // if ([USER_ROLES.OPE, USER_ROLES.OPM].includes(role)) {
        //   const checkerDetailsRes = await (dispatch(getCheckerDetails()) as unknown as Promise<any>);

        //   dispatch(storeIwappId({ iwappRmId: checkerDetailsRes?.approverId }));

        //   navbarInfoData = {
        //     ...navbarInfoData,
        //     rmName: checkerDetailsRes?.name ?? "",
        //     userRole: checkerDetailsRes?.userRole ?? ""
        //   }
        // }
      } catch (error) {
        console.error("Error: ", error)
      } finally {
        dispatch(setNavbarInfo(navbarInfoData));
        dispatch(setNavbarInfoLoading(false));
      }
    }

    fetch()
  }, [userId, history.location.pathname]);

  const ScrollToTopOnPageChange = () => {

    useEffect(() => {
      const unlisten = history.listen(() => {
        window.scrollTo(0, 0); // Scroll to the top of the page on route change
      });
      return () => {
        unlisten();
      };
    }, [history]);

    return null;
  };

  const individualSelected = diyAccountType === 'individual account';
  const nonIndividualSelected = diyAccountType === 'non-individual account';
  const jointSelected = diyAccountType === 'joint account';

  const getBaseRoute = () => {
    // if ([
    //   USER_ROLES.RM,
    //   USER_ROLES.DISTRIBUTOR,
    //   USER_ROLES.SUBDISTRIBUTOR,
    //   USER_ROLES.OPE,
    //   USER_ROLES.OPM
    // ].includes(role)) {
    if (![USER_ROLES.INVESTOR].includes(role) && isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" })) {
      // return '/applications';
      return '/dashboard';
    }
    else if ([USER_ROLES.AMCAPPROVER].includes(role) && [USER_ROLES.POACHECKER].includes(subRole)) {
      return '/payments-approval';
    }
    else if (
      [
        USER_ROLES.TRUSTEE,
        USER_ROLES.FUND_MANAGER,
        USER_ROLES.POAAPPROVER,
        USER_ROLES.AMCAPPROVER,
      ].includes(role)
    ) {
      return '/applications-list';
    } else if ([USER_ROLES.AMC_ADMIN].includes(role)) {
      // return '/dashboard';
      return '/user-management';
    } else if ([USER_ROLES.INVESTOR].includes(role)) {
      // return '/dashboard';
      if (((individualSelected || jointSelected) && diyInvOnboardingPrev)) {
        return `/investor-onboarding-application-details/${applicationId}`;
      }
      if (nonIndividualSelected && diyInvOnboardingPrev) {
        return `/non-individual-application-preview/${applicationId}`;
      }
      if (individualSelected && !diyIsKycDone) {
        return '/kyc-doc-selection'
      }
      if (individualSelected && diyInvestorOnboardingEdit) {
        return '/investor-onboarding-application/personal-details'
      }
      if (diyInvestorOnboarding) {
        return '/investor-onboarding-application/personal-details'
      }
      return '/investor-dashboard';
    } else if ([USER_ROLES.ANALYST].includes(role)) {
      return '/reports-download'
    }
    else {
      return '/applications';
    }
  };

  return (
    <Router history={history}>
      {ScrollToTopOnPageChange()}
      <NomineeRequiredPopup />
      <Switch>
        <Route
          exact
          path="/"
          render={(props: any) => (
            <Redirect {...props} to={getBaseRoute()} from={props.location.pathname} />
          )}
        />
        <RedirectRoute path="/login/:referenceId" component={MobileLogin} />
        <RedirectRoute path="/login" component={MobileLogin} />
        <RedirectRoute path="/cyberarc-callback" component={LoadingAdid} />
        <RedirectRoute path="/verify-otp" component={LoginOtp} />
        <RedirectRoute path="/consent-otp/:id/:userId/:referenceId" component={ConsentOtp} />
        <RedirectRoute path="/joint-holder" component={JointHolderType} />
        <RedirectRoute path="/select-role" component={SelectRole} />
        <RedirectRoute path="/investor-onboarding" component={InvOnboardingRoutes} />
        <ProtectedRoute path="/app-launcher" component={AppLauncher} customAuthorizationCheck={true} />
        <ProtectedRoute path="/kyc-doc-selection" component={KycDocSelection} acceptedRoles={[USER_ROLES.INVESTOR]} />
        <ProtectedRoute path="/ckyc-verification" component={CKYCPage} acceptedRoles={[USER_ROLES.INVESTOR]} />
        <ProtectedRoute path="/digiLocker/:referenceId" component={Digilocker} acceptedRoles={[USER_ROLES.INVESTOR]} />
        <ProtectedRoute path="/digiLocker" component={Digilocker} acceptedRoles={[USER_ROLES.INVESTOR]} />
        <Route
          path="/bsetrade"
          component={BseTradeSuccess}
        // acceptedRoles={[USER_ROLES.INVESTOR]}
        />
        <ProtectedRoute path="/my-profile" component={MyProfileRouter} acceptedRoles={[USER_ROLES.RM]} />
        <ProtectedRoute path="/investor-onboarding-application" component={InvApplicationRoutes} acceptedRoles={[USER_ROLES.INVESTOR]} />
        <ProtectedRoute path="/verify-form-otp" component={VerifyFormSubmitOTP} acceptedRoles={[USER_ROLES.INVESTOR]} />
        <ProtectedRoute path="/add-diy-joint-holder" component={InvOnboardingRoutes} acceptedRoles={[USER_ROLES.INVESTOR]} />
        <ProtectedRoute
          path="/dashboard"
          component={Dashboard}
          // acceptedRoles={[USER_ROLES.RM]}
          // acceptedRoles={[
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          //   USER_ROLES.OPE,
          //   USER_ROLES.OPM
          // ]}
          customAuthorizationCheck={
            ![USER_ROLES.INVESTOR].includes(role) && isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" })
          }
        />
        {/* <ProtectedRoute path="/analytics" component={Analytics} acceptedRoles={[USER_ROLES.RM]} /> */}
        <ProtectedRoute
          path='/fundDetails'
          component={IndividualFundDetails}
          acceptedRoles={[
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM
          ]}
        />
        <Route path="/product">
          <Switch>
            <Route exact path="/product" render={() => <Redirect to="/product/mutual-fund" />} />
            <ProtectedRoute
              path="/product"
              component={ProductsRouter}
              // acceptedRoles={[USER_ROLES.RM, USER_ROLES.INVESTOR]}
              customAuthorizationCheck
            />
          </Switch>
        </Route>
        <Route path="/bank">
          <Switch>
            <Route exact path="/bank" render={() => <Redirect to="/bank/updateBank" />} />
            <ProtectedRoute
              path="/bank"
              component={BanksRouter}
              acceptedRoles={[USER_ROLES.RM, USER_ROLES.INVESTOR]}
            />
          </Switch>
        </Route>
        <Route path="/nominee">
          <Switch>
            <Route exact path="/nominee" render={() => <Redirect to="/nominee/updateNominee" />} />
            <ProtectedRoute
              path="/nominee"
              component={NomineeRouter}
              acceptedRoles={[USER_ROLES.RM, USER_ROLES.INVESTOR]}
            />
          </Switch>
        </Route>
        <Route path="/analytics">
          <Switch>
            <Route exact path="/analytics" render={() => <Redirect to="/analytics/mutual-fund-research" />} />
            <ProtectedRoute
              path="/analytics"
              component={AnalyticsRouter}
              // acceptedRoles={[USER_ROLES.RM]}
              moduleCode="AnalyticsDashboard"
            />
          </Switch>
        </Route>
        <Route path="/orders">
          <Switch>
            <Route exact path="/orders" render={() => <Redirect to="/orders/order-dashboard" />} />
            <ProtectedRoute
              path="/orders"
              component={OrderManagementRouter}
              // acceptedRoles={[USER_ROLES.RM]}
              customAuthorizationCheck
            />
          </Switch>
        </Route>
        <ProtectedRoute
          path="/investors"
          component={InvestorDashboard}
          acceptedRoles={[
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM
          ]}
        />
        <ProtectedRoute
          path="/onboard-overview"
          component={OnBoardingDashBoard}
          acceptedRoles={[
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM
          ]}
        />
        {/* <ProtectedRoute path="/joint-holder" component={JointHolderType} acceptedRoles={[USER_ROLES.INVESTOR]} /> */}
        <ProtectedRoute
          path="/investor-dashboard"
          component={InvestorLoginRouter}
          // acceptedRoles={[USER_ROLES.INVESTOR]}
          moduleCode="INVDashboard"
        />
        <ProtectedRoute
          path="/investor-recommendations"
          component={InvestorRecommendations}
          acceptedRoles={[USER_ROLES.INVESTOR]}
        />
        <ProtectedRoute
          path="/cart"
          component={CartRouter}
          // acceptedRoles={[USER_ROLES.INVESTOR]}
          moduleCode="MFOrders"
        />
        <ProtectedRoute
          path="/investor-details"
          component={InvestorDetails}
          acceptedRoles={[
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM
          ]}
        />
        <ProtectedRoute
          path="/total-rm-detail"
          component={TotalRmDetail}
          acceptedRoles={[
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM
          ]}
        />
        <ProtectedRoute
          path="/book-size-detail"
          component={BookSizeDetail}
          acceptedRoles={[
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM
          ]}
        />
        <ProtectedRoute path="/net-sales" component={NetSales} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} />
        <ProtectedRoute path="/total-revenue" component={TotalRevenue} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} />
        <ProtectedRoute path="/investor-transactions" component={InvestorTransactions} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} />
        <ProtectedRoute path="/recommended-schemes" component={RecommendedSchemes} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} />
        <ProtectedRoute path="/holdings" component={Holding} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} />
        {/* <ProtectedRoute path="/orders" component={Orders} acceptedRoles={[USER_ROLES.RM]} /> */}
        <ProtectedRoute path="/SIP_Lumpsum" component={SIPLumpsum} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} />
        <ProtectedRoute path="/STP_SWP" component={STP_SWP} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} />
        <ProtectedRoute path="/Switch" component={SwitchComp} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} />
        <ProtectedRoute path="/Redeem" component={Redeem} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} />

        <ProtectedRoute
          path="/gross-sales"
          component={GrossSales}
          acceptedRoles={[
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM
          ]}
        />
        <ProtectedRoute
          path="/applications"
          component={Investors}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          // ]}
          moduleCode="APPL"
        />
        <ProtectedRoute
          path="/account-status"
          component={AccountStatus}
          acceptedRoles={[
            USER_ROLES.RM,
          ]}
        />
        <ProtectedRoute
          path="/re-kyc-status"
          component={ReKYCStatus}
          moduleCode="ReKYC"
        />
        <ProtectedRoute
          path="/non-mf-applications"
          component={NonMFApplications}
          moduleCode="NONMFAPPL"
        />
        <ProtectedRoute
          path="/create-account"
          component={CreateJointHolder}
          acceptedRoles={[
            USER_ROLES.RM,
            // USER_ROLES.INVESTOR,
          ]}
        />
        <ProtectedRoute
          path="/bank/updateBank"
          component={UpdateBank}
          moduleCode="EDITBANK"
        />
        <ProtectedRoute
          path="/nominee/updateNominee"
          component={UpdateNominee}
          moduleCode="EDITNOMINEE"
        />
        <ProtectedRoute
          path="/joint-holder-application-details/:id"
          component={JointHolderDetails}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
            USER_ROLES.POAAPPROVER,
            USER_ROLES.AMCAPPROVER,
            USER_ROLES.INVESTOR,
          ]}
        />
        <ProtectedRoute
          path="/onboarding"
          component={OnboardingRouter}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          //   USER_ROLES.AMCAPPROVER,
          // ]}
          moduleCode="INVOnboard"
        />
        <ProtectedRoute
          path="/investor-profile/:investorId"
          component={InvestorProfileRouter}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          //   USER_ROLES.AMCAPPROVER,
          // ]}
          moduleCode="INVDashboard"
        />
        <ProtectedRoute
          path="/family-profile/:familyId"
          component={FamilyDetails}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
            USER_ROLES.AMCAPPROVER,
          ]}
        />
        <ProtectedRoute
          path="/application"
          component={ApplicationRoutes}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          // ]}
          moduleCode="INVOnboard"
        />
        <ProtectedRoute
          path="/notifications"
          component={Notifications}
          acceptedRoles={[
            USER_ROLES.RM,
            USER_ROLES.INVESTOR,
          ]}
        />
        <ProtectedRoute
          path="/non-individual-application"
          component={NonIndividualApplicationRoutes}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          // ]}
          moduleCode="INVOnboard"
        />
        <ProtectedRoute
          path="/profile"
          component={Profile}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
          ]}
        />
        <ProtectedRoute
          path="/application-details/:id"
          component={ApplicationDetails}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          //   USER_ROLES.POAAPPROVER,
          //   USER_ROLES.AMCAPPROVER,
          // ]}
          moduleCode="APPL"
        />
        <ProtectedRoute
          path="/application-checker-details/edit-application"
          component={EditApplication}
          acceptedRoles={[
            USER_ROLES.AMCAPPROVER,
          ]}
        // moduleCode="INVOnboard"
        />
        <ProtectedRoute
          path="/investor-onboarding-application-details/:id"
          component={ApplicationDetails}
          acceptedRoles={[
            USER_ROLES.INVESTOR
          ]}
        />
        <ProtectedRoute
          path="/funds-setup"
          component={FundsSetup}
          acceptedRoles={[USER_ROLES.AMC_ADMIN]}
        />
        <ProtectedRoute
          path="/risk-profile"
          component={RiskProfile}
          acceptedRoles={[USER_ROLES.AMC_ADMIN]}
        />
        <ProtectedRoute
          path="/amc-admins"
          component={AMCAdminsList}
          acceptedRoles={[USER_ROLES.SUPER_ADMIN, USER_ROLES.DISTRIBUTOR]}
        />
        <ProtectedRoute
          path="/reports"
          component={Reports}
          // acceptedRoles={[USER_ROLES.RM, USER_ROLES.AMC_ADMIN, USER_ROLES.AMCAPPROVER]}
          moduleCode="OnboardReport"
        />
        <ProtectedRoute
          path="/ovd-reports"
          component={OVDReports}
          // acceptedRoles={[USER_ROLES.RM, USER_ROLES.AMC_ADMIN, USER_ROLES.AMCAPPROVER]}
          moduleCode="DMDOVDReport"
        />
        <ProtectedRoute
          path="/subbroker-reports"
          component={SubbrokerReports}
          moduleCode="SUBBROKERREPORT"
        />
        <ProtectedRoute
          path="/applications-list"
          component={ApplicationEsignList}
          // acceptedRoles={[
          //   USER_ROLES.TRUSTEE,
          //   USER_ROLES.FUND_MANAGER,
          //   USER_ROLES.POAAPPROVER,
          //   USER_ROLES.AMCAPPROVER,
          // ]}
          moduleCode="APPL"
        />
        <ProtectedRoute
          path="/orders-approval"
          component={OrdersApproval}
          acceptedRoles={[
            USER_ROLES.AMCAPPROVER,
          ]}
        />
        <ProtectedRoute
          path="/order-details"
          component={OrderDetails}
          acceptedRoles={[
            USER_ROLES.AMCAPPROVER,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM
          ]}
        />
        <ProtectedRoute
          path="/payments-approval"
          component={PaymentsApproval}
          acceptedRoles={[
            USER_ROLES.AMCAPPROVER,
          ]}
        />
        <ProtectedRoute
          path="/payment-details"
          component={PaymentDetails}
          acceptedRoles={[
            USER_ROLES.AMCAPPROVER,
          ]}
        />
        <ProtectedRoute
          path="/user-management"
          component={UserManagementLayOut}
          // acceptedRoles={[USER_ROLES.AMC_ADMIN]}
          moduleCode="RML"
        />
        <ProtectedRoute
          path="/non-individual-application-details/:id"
          component={NonIndividualApplicationDetail}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          //   USER_ROLES.AMCAPPROVER,
          // ]}
          moduleCode="APPL"
        />
        <ProtectedRoute
          path="/non-individual-application-edit"
          component={NonIndividualApplicationEdit}
          acceptedRoles={[USER_ROLES.AMCAPPROVER]}
        />
        <ProtectedRoute
          path="/application-preview/:id"
          component={ApplicationDetails}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          // ]}
          moduleCode="INVOnboard"
        />
        <ProtectedRoute
          path="/investor-onboarding-application-preview/:id"
          component={ApplicationDetails}
          acceptedRoles={[
            USER_ROLES.INVESTOR,
          ]}
        />
        <ProtectedRoute
          path="/non-individual-application-preview/:id"
          component={NonIndividualApplicationDetail}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          // ]}
          moduleCode="INVOnboard"
        />
        <Route path='/payment-flow' component={PaymentRouter} />
        <Route path="/investment-details" component={InvestorRoutes} />
        <Route path="/investor-consent/:verificationToken" component={ConsentEmailApproveReject} />
        <Route path="/investor-consent-approved" component={ConsentEmailApprove} />
        <Route path="/investor-consent-reject" component={ConsentEmailReject} />
        <ProtectedRoute
          path="/view-consent-email-list"
          component={ConsentEmailApplicationsList}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.OPE,
          //   USER_ROLES.OPM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          //   USER_ROLES.AMCAPPROVER,
          // ]}
          moduleCode="INVOnboard"
        />
        <ProtectedRoute
          path="/admin-support"
          component={adminSupport}
          acceptedRoles={[USER_ROLES.AMC_ADMIN]}
        />
        <ProtectedRoute
          path="/rm-mapping-change"
          component={uploadRMMapping}
          acceptedRoles={[USER_ROLES.AMC_ADMIN]}
        />
        <Route path="/">
          <Switch>
            <ProtectedRoute
              exact
              path="/investor"
              component={IndividualInvestor}
              acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]}
            />
            {/* <ProtectedRoute
              path="/investor-reports"
              component={InvestorReportRoute}
              acceptedRoles={[USER_ROLES.RM]}
            /> */}
            <ProtectedRoute
              path="/investor-reports"
              component={InvestorReportRoute}
              // acceptedRoles={[USER_ROLES.INVESTOR]}
              moduleCode="INVReports"
            />
            <ProtectedRoute
              path="/reports-download"
              component={DashboardReportRoute}
              // acceptedRoles={[USER_ROLES.RM, USER_ROLES.AMC_ADMIN, USER_ROLES.ANALYST]}
              moduleCode="INVReports"
            />
            <ProtectedRoute
              path="/investor/mutual-fund"
              component={ProductDetails}
              acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]}
            />
            <ProtectedRoute
              path="/investor/direct-equity"
              component={DirectEquity}
              acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]}
            />
            <ProtectedRoute path="/investor/pms" component={PMS} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} />
            <ProtectedRoute path="/investor/aif" component={AIF} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} />
          </Switch>
        </Route>
        <LoginRequireRoute path="*" />
      </Switch>
    </Router>
  );
}

export default AppRoutes;
